import React from "react";
import { Box, Typography } from "@mui/material";
import ContinuousProgressLoader from "./ContinuousProgressLoader";

const EmailSendingLoader = ({
  size = "small",
  color = "primary",
  className = "",
  style = {},
}) => {
  const steps = [
    "Pulling operation users...",
    "Generating email content...",
    "Sending mail...",
  ];

  const [currentStep, setCurrentStep] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prevStep) => (prevStep === 2 ? prevStep : prevStep + 1));
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        ...style,
      }}
      className={className}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            color: "#FFF",
            fontWeight: 500,
          }}
        >
          {steps[currentStep]}
        </Typography>
      </Box>
      <ContinuousProgressLoader
        variant="wave"
        size={size}
        color={color}
        showMessage={false}
      />
    </Box>
  );
};

export default EmailSendingLoader;
